export const devUrlService = 'https://devapp.consolidez.com/v1.8';
export const prodUrlService = 'https://app.consolidez.com/v1.8';
